export const checkIfStringContainsScriptTags = (str: string): boolean => {
  if (!str) {
    return false;
  }
  const scriptTagRegex = /<[\s|\t]*script.*>/;
  const scriptTags = str.match(scriptTagRegex);
  return Boolean(scriptTags?.length);
};
